module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('v-row', [_c('v-dialog', {
    attrs: {
      "content-class": "all-dialog-wrapper",
      "persistent": ""
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [(!_vm.isLoading) ? [_c('v-row', {
    staticClass: "close-button"
  }, [_c('v-col', [_c('img', {
    staticClass: "closse-icon-modal",
    attrs: {
      "src": "/static/img/closse.svg"
    },
    on: {
      "click": _vm.closse
    }
  })])], 1), _vm._v(" "), _c('v-form', {
    staticClass: "wrapper-modal"
  }, [_c('v-row', {
    staticClass: "title-text"
  }, [_c('v-col', [_vm._v("\n                Оплата \n              ")])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "text-auth"
  }, [_c('v-col', [_c('div', {
    attrs: {
      "id": "payment-form"
    }
  })])], 1)], 1)] : _vm._e(), _vm._v(" "), (_vm.isLoading) ? [_c('div', {
    staticClass: "wrapper-loading"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "red"
    }
  })], 1)] : _vm._e()], 2)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10f51ddf","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modals/pay/pay.vue
// module id = 339
// module chunks = 2